import React, { FC } from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';

import ColorWrapper, { WithColor } from '@styles/colors';
import { font } from '@styles/fonts';
import Svg from '@styles/icons/svg';
import { scale } from '@components/frame';
import TouchableElement from '@components/common/touchableElement';
import Dropdown from '@components/common/dropdown';
import { DashboardOverviewDateRange } from '@reducers/v2/dashboard/types';

import { useManageDashboardOverviewDateRangeMoreSelector } from './hooks/useManageDashboardOverviewDateRangeMoreSelector';
import { DASHBOARD_PRESS_HOVER_BG_COLOR } from '@v2/pages/dashboard/common/constants/colors';

export interface DashboardOverviewDateRangeMoreSelectorProps extends WithColor {
  selectedDateRange: DashboardOverviewDateRange;
  onSelectDateRange: (dateRange: DashboardOverviewDateRange) => void;
}

const DashboardOverviewDateRangeMoreSelector: FC<DashboardOverviewDateRangeMoreSelectorProps> = ({ C, selectedDateRange, onSelectDateRange }) => {
  const { items, isExtendedOnly, triggerLabel } = useManageDashboardOverviewDateRangeMoreSelector({ selectedDateRange });

  return (
    <Dropdown
      items={items}
      selectedValue={selectedDateRange}
      onChange={onSelectDateRange}
      menuAlignment="left"
      menuStyle={{ width: undefined, minWidth: scale(160) }}
      optionStyle={{ height: scale(40) }}
      optionTextStyle={({ isSelected }) => ({
        ...font[isSelected ? 'Subhead 1 bold' : 'Button 1'],
        color: C(isSelected ? 'System/Light/Blue' : 'Label/Light/Tertiary'),
        flex: 1,
      })}
      renderTrigger={({ triggerRef, onPress }) => (
        <TouchableElement onPress={onPress}>
          {({ boxStyle, pressHoverColor }) => (
            <View
              ref={triggerRef}
              style={[
                boxStyle,
                {
                  flexDirection: 'row',
                  alignItems: 'center',
                  paddingVertical: scale(4),
                  paddingHorizontal: scale(10),
                  borderRadius: scale(8),
                  backgroundColor: C(isExtendedOnly ? 'Background/Light/Secondary' : pressHoverColor(DASHBOARD_PRESS_HOVER_BG_COLOR)),
                  gap: scale(4),
                },
              ]}
            >
              <Text
                style={[font['Button 1'], { color: C(isExtendedOnly ? 'System/Light/Blue' : 'Label/Light/Tertiary') }]}
              >
                {i18n.t(triggerLabel)}
              </Text>
              <Svg
                icon="activeMachine"
                color={C(isExtendedOnly ? 'System/Light/Blue' : 'Label/Light/Tertiary')}
                width={scale(6)}
                height={scale(7)}
                transform="rotate(90) translate(1 0)"
              />
            </View>
          )}
        </TouchableElement>
      )}
    />
  );
};

export default ColorWrapper(DashboardOverviewDateRangeMoreSelector);
